// Stepts for homepage
const onboardingSiteSteps = [
{
        element: ".main-headline",
        popover: {
            title: '🙋 <br>Začínáme',
            description: '<b>Tohle je onboarding stránka,</b> které pomáhá nalodit talenty do firmy.',
            position: 'bottom-left',
            showButtons: true,         // Do not show control buttons in footer
        },
},
{
    element: ".timeline-wrapper",
    popover: {
        title: '🥳<br>Timeline',
        description: 'Každá fáze náboru má vlastní stránku, přepínat mezi nimi můžeš zde. V červeném kolečku <div class="badge badge-timeline-red"><span>1</span></div> vidíš počet zaměstnanců, kteří právě danou fází náboru procházejí.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".medium-editor",
    popover: {
        title: ' ',
        description: 'Obsah stránky lze editovat kliknutím přímo do textu jako ve Wordu.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".footer-bottom-fixed",
    popover: {
        title: '🥳 <br>Hotovo!',
        description: '<b>Nezapomeň, že do průvodce se můžeš kdykoli vrátit</b> kliknutím na ikonu lodě Onboardio vlevo dole.<br>',
        position: 'top-right',
        showButtons: true,         // Do not show control buttons in footer
        nextBtnText: 'Rozumím',
        doneBtnText: 'Rozumím',        // Next button text for this step
    },
},
]



export default onboardingSiteSteps
